export const ANALYTICS_ACTION_KEYBOARD_SHORTCUTS = 'viewKeyboardShortcuts';
export const ANALYTICS_ACTION_VIEW_ALL_ISSUES = 'viewAllIssues';
export const ANALYTICS_ACTION_CREATE_ISSUE = 'createIssue';
export const ANALYTICS_ACTION_GET_HELP = 'getHelp';
